import React from "react";
import { IonPage, IonContent } from "@ionic/react";

const LoadingScreen: React.FC<{ message?: string }> = ({ message }) => (
  <IonPage>
    <IonContent className="ion-padding">
      <div className="flex flex-col items-center justify-center min-h-full">
        <div className="relative mb-8">
          <div className="absolute inset-0 animate-ping">
            <div className="w-28 h-28 bg-gradient-primary rounded-full opacity-20" />
          </div>
          <div className="relative w-28 h-28 bg-gradient-primary rounded-full flex items-center justify-center shadow-2xl animate-pulse-slow">
            <i className="fa-solid fa-graduation-cap text-5xl text-white" />
          </div>
        </div>
        <h2 className="text-white text-2xl font-black tracking-wide">Scholeo</h2>
        <div className="flex gap-2 mt-5">
          <div className="w-3 h-3 bg-primary-500 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
          <div className="w-3 h-3 bg-success-500 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
          <div className="w-3 h-3 bg-accent-500 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
        {message && <p className="text-gray-400 text-sm mt-6 animate-pulse">{message}</p>}
      </div>
    </IonContent>
  </IonPage>
);

export default LoadingScreen;
